import { render, staticRenderFns } from "./user.vue?vue&type=template&id=1212f685&scoped=true&"
import script from "./user.ts?vue&type=script&lang=ts&"
export * from "./user.ts?vue&type=script&lang=ts&"
import style0 from "./user.scss?vue&type=style&index=0&id=1212f685&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1212f685",
  null
  
)

export default component.exports